import { useState, useEffect, useCallback } from 'react'
import { useVestigioService } from 'hooks/useVestigioService'

export const useFormDocumento = ({ exame, form, idExameSolicitado, idExameRealizado, setDisableBotaoAvancar }) => {
  const vestigioService = useVestigioService()

  const [arrayFiliacao, setArrayFiliacao] = useState(['filiacao0', 'filiacao1'])
  const [vestigiosExtraidosDeCadaver, setVestigiosExtraidosDeCadaver] = useState([])
  const [processandoVestigiosExtraidosDeCadaver, setProcessandoVestigiosExtraidosDeCadaver] = useState(false)

  const fetchVestigiosExtraidosDeCadaver = useCallback(async () => {
    try {
      const response = await vestigioService.listarVestigiosDeExameSolicitadoExtraidosDeCadaverAsync(
        idExameSolicitado,
        setProcessandoVestigiosExtraidosDeCadaver
      )
      setVestigiosExtraidosDeCadaver(response)
    } catch (error) {
      console.error('Failed to fetch vestigios', error)
    }
  }, [idExameSolicitado])

  useEffect(() => {
    fetchVestigiosExtraidosDeCadaver()
  }, [fetchVestigiosExtraidosDeCadaver])


  useEffect(() => {
    if (!exame) return

    let objectFiliacoes = {}
    const splittedDataNascimento = exame.dataNascimento?.split('-') || []
    let [ano, mes, dia] = splittedDataNascimento

    if (exame.filiacoes?.length > 0) {
      let arrayFiliacoesDocumento = []
      exame.filiacoes.forEach((filiacao, index) => {
        objectFiliacoes = {
          ...objectFiliacoes,
          [`filiacao${index}`]: filiacao,
        }
        arrayFiliacoesDocumento.push(`filiacao${index}`)
      })

      setArrayFiliacao(arrayFiliacoesDocumento)
      form.setFormState((formState) => ({
        ...formState,
        values: {
          ...formState.values,
          ...exame,
          ...objectFiliacoes,
          dataNascimento: splittedDataNascimento.length ? `${dia}-${mes}-${ano}` : null,
          dataNascimentoFormatada: splittedDataNascimento.length ? `${ano}-${mes}-${dia}` : null,
        },
      }))
    } else {
      form.setFormState((formState) => ({
        ...formState,
        values: {
          ...formState.values,
          ...exame,
          dataNascimento: splittedDataNascimento.length ? `${dia}-${mes}-${ano}` : '',
          dataNascimentoFormatada: splittedDataNascimento.length ? `${ano}-${mes}-${dia}` : null,
        },
      }))
      setArrayFiliacao(['filiacao0', 'filiacao1'])
    }
  }, [exame])

  const mostrarFormularioDadosDocumento = useCallback(
    (vestigios) => {
      let result = true
      vestigios.forEach((vestigio) => {
        if (vestigio.anaNecPaps) {
          vestigio.anaNecPaps.forEach((analise) => {
            if (analise.id_exame_necropapiloscopico == idExameRealizado) {
              if (
                analise.resultado === 'NAO_IDENTIFICADO_SISTEMA' ||
                analise.resultado === 'NAO_IDENTIFICADO_FALTA_DOCUMENTO' ||
                analise.resultado === 'NAO_IDENTIFICADO_SEM_IMPRESSAO_PAPILAR'
              ) {
                result = false
              }
            }
          })
        }
      })
      return result
    },
    [idExameRealizado]
  )

  const mostrarTextoResultadoNegativo = useCallback(
    (vestigios) => {
      let resultado = null
      vestigios.forEach((vestigio) => {
        if (vestigio.anaNecPaps) {
          vestigio.anaNecPaps.forEach((analise) => {
            if (analise.id_exame_necropapiloscopico == idExameRealizado) {
              if (analise.resultado === 'NAO_IDENTIFICADO_SISTEMA') {
                resultado = 'Não foram encontrados dados para confronto necropapiloscópico.'
              } else if (analise.resultado === 'NAO_IDENTIFICADO_FALTA_DOCUMENTO') {
                resultado = 'Não identificado por falta de documento.'
              } else if (analise.resultado === 'NAO_IDENTIFICADO_SEM_IMPRESSAO_PAPILAR') {
                resultado = 'Não identificado por impossibilidade de extração de impressão papilar.'
              }
            }
          })
        }
      })
      return resultado
    },
    [idExameRealizado]
  )

  useEffect(() => {
    let result = false
    if (mostrarFormularioDadosDocumento(vestigiosExtraidosDeCadaver)) {
      if (
        !form.formState.values.nome ||
        !form.formState.values.numeroDocumento ||
        !form.formState.values.tipoDocumento ||
        !form.formState.values.dataNascimentoFormatada
      ) {
        result = true
      }
    }
    setDisableBotaoAvancar(result)
  }, [form.formState.values, vestigiosExtraidosDeCadaver, mostrarFormularioDadosDocumento, setDisableBotaoAvancar])

  const handleAdicionarFiliacao = useCallback(() => {
    setArrayFiliacao((prev) => {
      const newInput = `filiacao${prev.length}`
      return [...prev, newInput]
    })
  }, [])


  const parseDataLocal = useCallback((dateString) => {
    if (!dateString) return null
    if (dateString instanceof Date) return dateString
    const parts = String(dateString).split('-')
    if (parts.length === 3) {
      const [ano, mes, dia] = parts
      return new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia))
    }
    const partsSlash = String(dateString).split('/')
    if (partsSlash.length === 3) {
      const [dia, mes, ano] = partsSlash
      return new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia))
    }
    return new Date(dateString)
  }, [])


  const handleDateChange = useCallback((date) => {
    if (!date || isNaN(Date.parse(date))) {
      form.setFormState((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          dataNascimento: null,
          dataNascimentoFormatada: null,
        },
      }))
      return
    }
    const d = new Date(date)
    const ano = d.getFullYear()
    const mes = String(d.getMonth() + 1).padStart(2, '0')
    const dia = String(d.getDate()).padStart(2, '0')

    form.setFormState((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        dataNascimento: `${dia}/${mes}/${ano}`,
        dataNascimentoFormatada: `${ano}-${mes}-${dia}`,
      },
    }))
  }, [])

  return {
    arrayFiliacao,
    vestigiosExtraidosDeCadaver,
    processandoVestigiosExtraidosDeCadaver,
    mostrarFormularioDadosDocumento,
    mostrarTextoResultadoNegativo,
    handleAdicionarFiliacao,
    parseDataLocal,
    handleDateChange,
  }
}
